import type { Entity } from '@backstage/catalog-model';
import type { JsonObject, StackOperation } from './stack';

export type ResourceOperationTemplateEntity = Entity & {
  kind: 'Template';
  spec: JsonObject & {
    type: 'resource-operation';
    resourceType: string;
    operation: StackOperation;
  };
};

export function isResourceOperationTemplate(
  entity: Entity,
): entity is ResourceOperationTemplateEntity {
  const spec = entity.spec as
    | {
        type?: unknown;
        stackType?: unknown;
        resourceType?: unknown;
        operation?: unknown;
      }
    | undefined;
  return (
    entity.kind === 'Template' &&
    spec?.type === 'resource-operation' &&
    spec.stackType === undefined &&
    typeof spec.resourceType === 'string' &&
    spec.resourceType.length > 0 &&
    ['create', 'update', 'action', 'delete'].includes(String(spec.operation))
  );
}

/**
 * Discover resource workflows by typed taxonomy and return their emitted
 * catalog identities. Callers must never reconstruct a template name.
 */
export function resourceOperationTemplatesFor(
  resourceType: string,
  namespace: string,
  templates: Entity[],
): ResourceOperationTemplateEntity[] {
  return templates
    .filter(isResourceOperationTemplate)
    .filter(
      template =>
        (template.metadata.namespace ?? 'default') === namespace &&
        template.spec.resourceType === resourceType,
    )
    .sort(
      (left, right) =>
        left.spec.operation.localeCompare(right.spec.operation) ||
        left.metadata.name.localeCompare(right.metadata.name),
    );
}
